/**
 * Serialize a WASM request object to a plain JS object for axios.
 * Replaces the repeated `JSON.parse(request.to_json())` pattern.
 */
export function wasmBody(request: { to_json(): string }): unknown {
  return JSON.parse(request.to_json());
}
